import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { StudioProvider } from "@/context/StudioContext";
import { Layout } from "@/components/Layout";
import { LoadingState } from "@/components/States";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import Channels from "@/pages/Channels";
import ChannelEditor from "@/pages/ChannelEditor";
import AITeam from "@/pages/AITeam";
import Integrations from "@/pages/Integrations";
import Settings from "@/pages/Settings";
import Pipeline from "@/pages/Pipeline";
import ProjectWorkspace from "@/pages/ProjectWorkspace";
import AnalyticsCosts from "@/pages/AnalyticsCosts";
import Earnings from "@/pages/Earnings";
import { Studio, Review } from "@/pages/ProductionPages";
import CommandCenter from "@/pages/CommandCenter";
import Calendar from "@/pages/Calendar";
import Research from "@/pages/Research";
import ModelRegistry from "@/pages/ModelRegistry";
import DirectorSettings from "@/pages/DirectorSettings";
import Autopilot from "@/pages/Autopilot";
import MCP from "@/pages/MCP";
import Styles from "@/pages/Styles";
import ChannelFactory from "@/pages/ChannelFactory";
import Growth from "@/pages/Growth";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0B0F17]">
        <LoadingState label="Loading workspace…" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <StudioProvider>{children}</StudioProvider>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/*"
        element={
          <Protected>
            <Layout>
              <Routes>
                <Route path="/" element={<Overview />} />
                <Route path="/channels" element={<Channels />} />
                <Route path="/channels/new" element={<ChannelEditor />} />
                <Route path="/channels/:id" element={<ChannelEditor />} />
                <Route path="/projects/:id" element={<ProjectWorkspace />} />
                <Route path="/command-center" element={<CommandCenter />} />
                <Route path="/research" element={<Research />} />
                <Route path="/pipeline" element={<Pipeline />} />
                <Route path="/autopilot" element={<Autopilot />} />
                <Route path="/factory" element={<ChannelFactory />} />
                <Route path="/growth" element={<Growth />} />
                <Route path="/styles" element={<Styles />} />
                <Route path="/studio" element={<Studio />} />
                <Route path="/review" element={<Review />} />
                <Route path="/calendar" element={<Calendar />} />
                <Route path="/analytics" element={<AnalyticsCosts />} />
                <Route path="/earnings" element={<Earnings />} />
                <Route path="/ai-team" element={<AITeam />} />
                <Route path="/registry" element={<ModelRegistry />} />
                <Route path="/mcp" element={<MCP />} />
                <Route path="/director" element={<DirectorSettings />} />
                <Route path="/integrations" element={<Integrations />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </Protected>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#0B0F17]">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-right" theme="dark" richColors />
    </div>
  );
}

export default App;
